import { Stack, Text } from '@mantine/core';
import { useEffect } from 'react';
import PanePaper from '../../../Molecules/PanePaper';
import { RoutingS } from '../../../Service/RoutingS';
import CalendarShares from './CalendarShares';
import CalendarAccess from './CalendarAccess';
import RecommendationMappings from './RecommendationBookingStateMappings';

const Team = () => {
  useEffect(() => {
    RoutingS.changeTitle('Dienstleister-Netzwerk');
  }, []);

  return (
    <PanePaper title="settings.team" tooltip="help.settings.team.pane">
      <Text>
        In jedem Event unter <i>Event-Details</i> steht Dir der Bereich <i>Dienstleister-Netzwerk</i> zur Verfügung.
        Wenn du dort Kollegen hinzufügst, kannst Du Aufträge schnell und einfach an Deine Kollegen übermitteln - egal ob
        sie ebenso bookitup nutzen oder nicht.
        <br />
        <br />
        Wenn Dein Kollege aber auch bookitup nutzt, kannst Du sein bookitup Konto (unter{' '}
        <i>Verfügbarkeit Deines Teams</i>) verknüpfen. Das System prüft dann automatisiert, ob der Kollege für das Event
        noch Zeit hätte (anhand seiner hinterlegten Events und privaten Kalender). Falls ja, kannst Du ihm die Anfrage
        weiterleiten. Diese wird dann automatisch in seinem bookitup Konto importiert.
      </Text>
      <Stack mt="md">
        <CalendarAccess />
        <CalendarShares />
        <RecommendationMappings />
      </Stack>
    </PanePaper>
  );
};

export default Team;
